import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { __ } from 'react-i18n';

import { StyledLink } from 'eshop-defaults';
import { FormInputComponent } from 'eshop-defaults';
import { Button } from 'eshop-defaults';
import { FlexRowCenterVertical } from 'eshop-defaults';
import {WarningAlert} from 'eshop-defaults';
import { ButtonPrimary } from 'eshop-defaults';
import { onlyPublic } from '../../utilities/only-public';
import { UrlHashService } from '../../services/UrlHashService';
import { rem } from 'polished';

interface Props {
  dispatch: any;
  getLoginUrl: () => string;
  handleFacebook: () => undefined;
  handleGoogle: () => undefined;
}

interface State {
  error: string;
  errorDescription?: string;
  username?: string;
}

class Login extends React.Component<Props, State> {
  public state = {
    error: '',
    errorDescription: '',
    username: '',
  };

  public componentDidMount() {
    const hashService = new UrlHashService();
    if (hashService.get('error')) {
      this.setState({
        error: decodeURIComponent(hashService.get('error', '')),
        errorDescription: decodeURIComponent(hashService.get('error', '')),
        username: decodeURIComponent(hashService.get('username', '')),
      });
    }
  }

  public onUsernameChange = e => {
    this.setState({ username: e.target.value });
  };
  public closeAlert = () => ({});

  public render() {
    return (
      <React.Fragment>
        {this.state.error && (
          <WarningAlert
            hideX={true}
            message={this.state.errorDescription || this.state.error}
            closeAlert={this.closeAlert}
          />
        )}

        <form method='POST' action={this.props.getLoginUrl()}>
          <FormInputComponent
            label={__('Email')}
            type='email'
            placeholder={__('bart@bart.sk')}
            name='username'
            autoComplete='email'
            value={this.state.username}
            onChange={this.onUsernameChange}
          />

          <FormInputComponent
            label={__('Heslo')}
            type='password'
            placeholder='***********'
            name='password'
            autoComplete='current-password'
          />
          <ButtonPrimary
            style={{ marginTop: 25 }}
            type='submit'
            roundOnMobile={true}
          >
            {__('Prihlásiť sa')}
          </ButtonPrimary>
        </form>

        <ForgottenPasswordContainer>
          <ForgottenPasswordLink to={__('routes:zabudnute-heslo')}>
            {__('Zabudli ste heslo?')}
          </ForgottenPasswordLink>
        </ForgottenPasswordContainer>

        <OrLabel>
          <Line />
          <OrText> {__('alebo')} </OrText>
          <Line />
        </OrLabel>

        <Button
          style={{ margin: '10px 0' }}
          roundOnMobile={true}
          color='#3B5998'
          click={this.props.handleFacebook}
        >
          <SocialsLogo src={'/images/facebook-box.svg'} />
          <ButtonText> {__('Prihlásenie cez Facebook')} </ButtonText>
        </Button>

        <Button
          style={{ margin: '10px 0' }}
          roundOnMobile={true}
          color='#DD4B39'
          click={this.props.handleGoogle}
        >
          <SocialsLogo src={'/images/google.svg'} />
          <ButtonText> {__('Prihlásenie cez Google')} </ButtonText>
        </Button>
      </React.Fragment>
    );
  }
}

export const ButtonText = styled.span`
  font-size: ${({ theme }) => theme.fontSizeS};
  margin: ${rem(10)};

  ${({ theme }) => theme.media.s`
    font-size: ${theme.fontSizeXXS};
  `};
`;

export const SocialsLogo = styled.img`
  width: ${rem(17)};
  height: auto;
`;

export const OrText = styled.p`
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-family: ${({ theme }) => theme.primaryFont || theme.fonts.primaryFont};
  color: ${({ theme }) => `#aaaaaa` || theme.colors.inactiveFontColor};
  margin-left: ${rem(15)};
  margin-right: ${rem(15)};
`;

export const Line = styled.div`
  background: ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
  width: 100%;
  height: ${rem(1)};
`;

export const OrLabel = styled(FlexRowCenterVertical)`
  width: 100%;
`;

const ForgottenPasswordContainer = styled.div`
  width: 100%;
  margin: ${rem(30)} 0 ${rem(20)};
  text-align: center;
`;

const ForgottenPasswordLink = styled(StyledLink)`
  font-size: ${({ theme }) => theme.fontSizeXS};
`;

export default onlyPublic(connect()(Login));
